import Utils from "../utils/utils";
import RequestManager from "./RequestManager";

const getDomain = async (domainId) => {
    const response = await RequestManager.get({
        url: "/domain/v1/" + domainId
    });

    return response;
};

const getAllProductsByDomain = async (domainId) => {
    const response = await RequestManager.get({
        url: `/domain/product/v1/${domainId}`
    });
    return response;
};

const updateDomain = async (domainId, body) => {
    const response = await RequestManager.put({
        url: "/domain/v1/" + domainId,
        body
    });

    return response;
};

const getAllDomains = async (firstCursor, lastCursor, prev, getLatest, paginated = false) => {
    const size = paginated ? undefined : -1;
    const urlParams = Utils.getUrlParams({ size, prev, firstCursor, lastCursor, getLatest });
    const response = await RequestManager.get({
        url: `/domain/v1${urlParams}`,
    });

    return {
        ...response,
        ...response.data
    };
};

const getPaginatedDomains = async (firstCursor, lastCursor, prev, getLatest) => {
    return getAllDomains(firstCursor, lastCursor, prev, getLatest, true);
};

const createDomain = async (body) => {
    const response = await RequestManager.post({
        url: "/domain/v1",
        body
    });
    return response;
};

const deleteDomain = async (id) => {
    const response = await RequestManager.del({
        url: "/domain/v1/" + id
    });
    return response;
};

const Domain = {
    getDomain,
    getAllProductsByDomain,
    updateDomain,
    getAllDomains,
    getPaginatedDomains,
    createDomain,
    deleteDomain
};

export default Domain;